const store = {
    user: {
        token: localStorage.getItem("TOKEN"),
        data: [],
        roles: JSON.parse(localStorage.getItem("ROLES")) || [],
    },
    users: {
        loading: false,
        data: [],
    },
    reviews: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: 10,
        total: null,
    },
    activeReviews: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: 10,
        total: null,
    },
    galleries: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: 10,
        total: null,
    },
    usersImages: {
        loading: false,
        data: [],
    },
    videos: {
        loading: false,
        data: [],
    },
    notifications: {
        data: [],
        loading: false
    },
    UnReadNotificationCount: 0,
    dashboard: {
        loading: false,
        total_reviews: 0,
        active_reviews: 0,
        inactive_reviews: 0,
        average_rate: 0,
        latest_reviews: [],
    }
};
export default store;
